/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useEffect } from "react";
import { Tooltip, IconButton } from "@mui/material";
import { isGuid } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "cms/icons/index";

const ComponentUsageColumn = (props) => {
    
    const { params } = props;
    const { row } = params;  // this is a component
    const { guid, label, reuse_count } = row;
    const { token } = useAuth();
    /*
       TODO:
           eventually remove this look up.
           reuse_count can be pre-populated to provide usage without a lookup (until you click for more info)
           but having this query here for now fixes cases where the data is not up to date yet
           reuse_count is populated when components are saved.
   */
    const [usage, setUsage] = useState();
    const [usageCount, setUsageCount] = useState(reuse_count);
    useEffect(() => {
        const fetchUsage = async () => {
            if (isGuid(guid)) {
                const _usage = await SimpliCityAdminSDK.component.getComponentUsage(token, guid);
                if (_usage) {
                    setUsage(_usage);
                    setUsageCount(_usage?.length);
                }
            }
        };
        fetchUsage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);
    
    
    return (
        <>
            {usageCount}
            <Tooltip
                arrow={true}
                placement='right'
                title={
                    <div style={{ padding: "1em" }}>
                        <div>
                            <strong>{label || "Untitled"} </strong>used in:
                        </div>
                        <ul style={{ paddingLeft: "1em", margin: "0", marginTop: "0.6em" }}>
                            {usage?.map((usageItem) => {
                                const { guid, nav_title } = usageItem;
                                return <li key={guid}>{nav_title}</li>;
                            })}
                        </ul>
                    </div>
                }
            >
                <IconButton color='neutral'>
                    <FontAwesomeIcon icon={regular.faCircleInfo} />
                </IconButton>
            </Tooltip>
        </>
    );
};

export { ComponentUsageColumn };
